var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33325C15.1459 3.34334 16.1274 3.42372 16.7678 4.06404C17.5 4.79627 17.5 5.97478 17.5 8.3318V13.3318C17.5 15.6888 17.5 16.8673 16.7678 17.5996C16.0355 18.3318 14.857 18.3318 12.5 18.3318H7.5C5.14298 18.3318 3.96447 18.3318 3.23223 17.5996C2.5 16.8673 2.5 15.6888 2.5 13.3318V8.3318C2.5 5.97478 2.5 4.79627 3.23223 4.06404C3.87255 3.42372 4.85414 3.34334 6.66667 3.33325",
    stroke: "#313131",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 2.91675C6.6665 2.22639 7.22615 1.66675 7.9165 1.66675H12.0832C12.7735 1.66675 13.3332 2.22639 13.3332 2.91675V3.75008C13.3332 4.44044 12.7735 5.00008 12.0832 5.00008H7.9165C7.22615 5.00008 6.6665 4.44044 6.6665 3.75008V2.91675Z",
    stroke: "#313131",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0832 9.16678L7.91654 13.3334M7.91652 9.16676L12.0832 13.3334",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.ae4def1e21dab8cf919cb7ee711a6669.svg";
export { ForwardRef as ReactComponent };